import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

const DeleteDepartModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <div
        style={{
          padding: "30px 20px",
          textAlign: "center",
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: "80px",
            height: "80px",
            background: "#fde2e2",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <FiTrash2 size={32} color="#dc2626" />
        </div>

        {/* TITLE */}
        <h4
          style={{
            fontWeight: 600,
            marginBottom: "10px",
            color: "#1f2937",
          }}
        >
          Confirm Delete
        </h4>

        {/* DESCRIPTION */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "14px",
            marginBottom: "25px",
            lineHeight: "1.6",
          }}
        >
          You want to delete all the marked items, this cant be undone once you
          delete.
        </p>

        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "15px",
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              background: "#f3f4f6",
              border: "1px solid #e5e7eb",
              color: "#111827",
              padding: "8px 18px",
              borderRadius: "6px",
              minWidth: "100px",
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleDelete}
            style={{
              background: "#ef4444",
              border: "none",
              color: "#fff",
              padding: "8px 18px",
              borderRadius: "6px",
              minWidth: "120px",
              fontWeight: 500,
            }}
          >
            Yes, Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDepartModal;